import baseConfigs from './base';

const configs = {
    ...baseConfigs,
    API_BUS_MANAGEMENT: 'https://api.futabus.vn',
    API_V1: 'https://api.vato.vn',
    API_V2: 'https://apiv2.vato.vn',
    API_STORAGE: 'https://api.vato.vn/storage',
    API_OFFICE: 'https://api-office.vato.vn',
    API_ADMIN: 'https://api-admin.vato.vn',
    API_TRACKING: 'https://api.vato.vn/tracking',
    API_FUTA_USER: 'https://futa-api.futabus.vn',
    WEB_ADMIN_HOST: 'https://admin.vato.vn',
    FIREBASE_API_KEY: 'AIzaSyBY4YyTl-CBp0QYPUIeZSGxFKA31MjG5Fc',
    FIREBASE_AUTH_DOMAIN: 'facecar-29ae7.firebaseapp.com',
    FIREBASE_DATABASE_URL: 'https://facecar-29ae7.firebaseio.com',
    FIREBASE_PROJECT_ID: 'facecar-29ae7',
    FIREBASE_STORAGE_BUCKET: 'facecar-29ae7.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '639535783968',
    FIREBASE_APP_ID: '1:639535783968:web:a127b59b35b1c992c81c45',
    FIREBASE_MEASUREMENT_ID: 'G-VVJZH75D6P',
    FIREBASE_VAPID: 'BMcNzJ-YwVW2F4cmJLx2n9sofiVK7WAX-FrrwbxCzfJM_cDTeHrM1newK70pKvZnpR9-dEBhLFq8MiHmcuT4EGc',
    gaTrackerId: 'G-FCVQFQ5D98',
    GOOGLE_MAP_KEY: 'AIzaSyBQLp608mbdjouAKW6iL_-71JENQ8QKG2s',
    CRM_WEB: 'https://crm.futabus.vn/',
    X_APP_ID: 'vn.futa.admin.city.bus',
};

export default Object.freeze(configs);
